/* eslint-disable @next/next/no-img-element */
"use client";

import { useRouter } from "@/navigation";
import { Card } from "@/sections/SliderCards";
import { ProductType } from "@/types/Products";
import {
  getComingSoonProducts,
  getNewProducts,
  getProductsByCategoryId,
  isProductComingSoon,
  isProductNew,
} from "@/utils/groupProductsByCategory";
import { AnimatePresence, motion } from "framer-motion";

type CategoryCardsProps = {
  categoryId?: number;
  isComingSoon?: boolean;
  isNew?: boolean;
  products: ProductType[];
};

const CategoryCards = ({
  categoryId,
  products,
  isComingSoon,
  isNew,
}: CategoryCardsProps) => {
  const router = useRouter();
  const groupedByCategory = getProductsByCategoryId(
    Number(categoryId),
    products || []
  );
  const groupedByComingSoon = getComingSoonProducts(products || []);
  const groupedByNew = getNewProducts(products || []);

  const choseCorrectProducts = () => {
    if (categoryId) {
      return groupedByCategory?.products;
    }
    if (isComingSoon) {
      return groupedByComingSoon;
    }
    if (isNew) {
      return groupedByNew;
    }
  };

  const renderTitle = () => {
    if (categoryId) {
      return groupedByCategory?.category.title;
    }
    if (isComingSoon) {
      return "Ожидается в блийжайшие 30 дней";
    }
    if (isNew) {
      return "Новое за 7 дней";
    }
  };

  const chosenProducts = choseCorrectProducts();
  return (
    <div className="category">
      <div
        style={{
          display: "flex",
          gap: "20px",
          alignItems: "center",
          marginBottom: "40px",
        }}
      >
        <button
          className="category__back-button"
          onClick={() => {
            router.push("/media-library");

            setTimeout(() => {
              const targetSection = categoryId
                ? document.getElementById(`category_${categoryId}`)
                : isComingSoon
                ? document.getElementById(`category_soon`)
                : document.getElementById(`new`);

              if (targetSection) {
                const targetPosition = targetSection.offsetTop - 80;

                window.scrollTo({
                  top: targetPosition,
                  behavior: "smooth",
                });
              }
            }, 1000);
          }}
        >
          <img
            src="/assets/images/left-arrow-black.svg"
            alt="left arrow"
            width={20}
            height={20}
          />
          Назад
        </button>
        <h1 className="category__title">{renderTitle()}</h1>
      </div>
      <div className="category__grid">
        <AnimatePresence>
          {chosenProducts?.map((product) => (
            <motion.div
              layout
              initial={{ opacity: 1, translateX: 0 }}
              exit={{
                opacity: 0,
                translateX: -20,
                transition: { duration: 0.2 },
              }}
              transition={{ duration: 0.3 }}
              key={product.id}
              className="category__card-holder"
            >
              <Card
                isNew={
                  product.activation_date
                    ? isProductNew(product.activation_date)
                    : false
                }
                isComingSoon={
                  product.activation_date
                    ? isProductComingSoon(product.activation_date!)
                    : false
                }
                card={product}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default CategoryCards;
